// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-expand-panel',
    // #endregion
    // #region Events
    emits: ['expanded', 'collapsed', 'collapsing', 'expanding'],
    // #endregion
    // #region Properties
    props: {
        key: {
            type: String,
            required: false,
            default: ''
        },
        index: {
            type: Number,
            required: false,
            default: 0
        },
        expanded: {
            type: Boolean,
            required: false,
            default: false
        },
        arrowLocation: {
            type: String,
            required: false,
            default: 'right'
        },
        headerClass: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: () => ({
        _IsExpanded: false,
    }),
    created() {
        this._IsExpanded = this.expanded;
    },
    watch: {
        expanded: function (newVal, oldVal) {
            this._IsExpanded = newVal;
        }
    },
    // #endregion
    // #region Methodes
    methods: {
        toggle() {
            if (this._IsExpanded) {
                //Args
                let tArgs = { key: this.key, index: this.index, succeeded: true };
                //Event
                this.$emit('collapsing', tArgs);
                //Open
                if (tArgs.succeeded) {
                    this._IsExpanded = false;
                }
                //Event
                this.$emit('collapsed', tArgs);
            }
            else {
                //Args
                let tArgs = { key: this.key, index: this.index, succeeded: true };
                //Event
                this.$emit('expanding', tArgs);
                //Open
                if (tArgs.succeeded) {
                    this._IsExpanded = true;
                }
                //Event
                this.$emit('expanded', tArgs);
            }
        }
    }
    // #endregion
});
// #endregion
